//@ts-ignore
import { ApiClient } from "../../lib/ApiClient";
import { useGenericSWR } from "../../lib/useGenericSWR";
import { SwrOptions } from "../../lib/useGenericSWR.interfaces";

const apiEndpoint = 'api/v1/UserNotificationCounter';
const apiClient = new ApiClient();

const useUserNotificationCounter = (userId?: number, swrOptions = {}) => {
    const params = new URLSearchParams();
    if (userId) {
        params.append('userId', userId.toString());
    }

    return useGenericSWR(userId ? apiEndpoint + "?" + params.toString() : "", apiClient, { ...swrOptions as SwrOptions });
};

export {
    useUserNotificationCounter
};